import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  RootState,
  selectActiveSession,
  setCommandsIsLoading,
} from '@helios/state-management'
import { HELIOS_COMMAND_HTTP_TOKEN } from '@helios/utils'
import { Store } from '@ngrx/store'
import { ToastService } from '@northfork/ng-basics'
import { Observable, throwError } from 'rxjs'
import { finalize, switchMap, take } from 'rxjs/operators'

@Injectable()
export class CommandsLoadingInterceptor implements HttpInterceptor {
  constructor(
    private readonly store: Store<RootState>,
    private readonly toastService: ToastService,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const isCommand = request.context.get(HELIOS_COMMAND_HTTP_TOKEN) ?? false

    if (!isCommand) {
      // Non-command requests: just pass through
      return next.handle(request)
    }

    // Check session auxiliary info for needsReview
    return this.store.select(selectActiveSession).pipe(
      take(1),
      switchMap(activeSession => {
        const hasSessionNeedsReview =
          activeSession?.auxiliaryInfo?.REQUEST_IDS &&
          activeSession?.auxiliaryInfo?.REQUEST_IDS.length > 0

        if (hasSessionNeedsReview) {
          this.toastService.error(
            'Session has commands pending approval',
            '',
            {
              closeButton: true,
              timeOut: 3000,
              disableTimeOut: false,
            },
            'Error: Command not created',
          )
          return throwError(
            () =>
              new HttpErrorResponse({
                status: 400,
                statusText: 'Session has pending review items; request blocked',
              }),
          )
        }

        // No needsReview in session: proceed with normal behaviour
        this.store.dispatch(setCommandsIsLoading({ isLoading: true }))

        return next.handle(request).pipe(
          finalize(() => {
            this.store.dispatch(setCommandsIsLoading({ isLoading: false }))
          }),
        )
      }),
    )
  }
}
